import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { signInWithEmailAndPassword } from "firebase/auth";
import { getMessaging,getToken } from "firebase/messaging";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCDekiOJv1nL2UqUKzxN5jHv_Z72MBX69w",
  authDomain: "music-player-32bab.firebaseapp.com",
  projectId: "music-player-32bab",
  storageBucket: "music-player-32bab.appspot.com",
  messagingSenderId: "939598810693",
  appId: "1:939598810693:web:1ac6eeeceaa16848fbdd2c",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const firestore = getFirestore(app);
const database = getDatabase();

const messaging = getMessaging(app);
const generateToken = async () =>{
  const permission = await Notification.requestPermission();
  if(permission === 'granted'){
  const token = await getToken(messaging, { vapidKey: 'BP2hUareACPYl8y0vyaOqJJGfjZ-_Bkfvy3I5y6knX7S7ZMb8aRYJk-5eFCAiNWJCDj8A2_Bh9L27cxcVnshOiM'});
  console.log(token);
  }
}


export { app , db, auth ,storage ,database,firestore,messaging,generateToken, signInWithEmailAndPassword };